export default {"src":"/_next/static/media/buycoffee.3b2297fa.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};